import Banner from "../Allcomponent/Banner"
import Fragrances from "../Allcomponent/Fragrances"
import Cards from "../Allcomponent/cards"
function Frang(){
    return(
        <>
        <Banner/>
        <Cards/>
        <Fragrances/>
        </>
    )
}
export default Frang